import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import MainLayout from "../layouts/MainLayout";
import QueryProvider from "../lib/query/provider";
import NotFound from "../pages/NotFound";
import FAQPage from "../pages/Faq";
import AdminTickets from "../pages/AllTickets";
import UnRsvp from "../pages/UnRsvp";

export const RoutesWrapper: React.FC = () => {
  return (
    <QueryProvider>
      <Routes>
        {/* Routes that share the Navbar */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/admin/guests" element={<AdminTickets />} />
        </Route>

        <Route path="/unrsvp/:token" element={<UnRsvp />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </QueryProvider>
  );
};
